import React, { useState } from "react";
import { Table, Pagination, Button, Input, Tag } from "antd";
import { AiOutlineFilter } from "react-icons/ai";
import moment from "moment";

import { IoLockClosed } from "react-icons/io5";
import { IoLockOpen } from "react-icons/io5";

function DataTable2(props) {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");

  const OnSelectChange = (newSelectedRowkeys, rowDetails) => {
    props.onSelect(rowDetails);
    setSelectedRowKeys(newSelectedRowkeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: OnSelectChange,
  };

  const totalWeight = (record) => {
    let Weight = record.boxes.reduce(function (tot, arr) {
      return Number(Number(tot) + Number(arr.chargable_weight)).toFixed(2);
    }, 0);
    return Weight;
  };

  const getTripStatus = (boxes) => {
    if (!Array.isArray(boxes) || boxes.length === 0) {
      return {
        label: "No Boxes",
        color: "#8c8c8c",
      };
    }

    const allFalseOrStatus13 = boxes.every(
      (box) => box.assign_to_trip === false || box?.status == 13
    );
    const allTrueOrNullAndNotStatus13 = boxes.every(
      (box) =>
        (box.assign_to_trip === true || box.assign_to_trip === null) &&
        box?.status !== 13
    );

    if (allFalseOrStatus13) {
      return {
        label: "Fully Received",
        color: "#52c41a",
      };
    } else if (allTrueOrNullAndNotStatus13) {
      return {
        label: "Pending",
        color: "#ff4d4f",
      };
    } else {
      return {
        label: "Partial Received",
        color: "#fa8c16",
      };
    }
  };
  // const getColumnSearchProps = (dataIndex) => ({
  //   filterDropdown: ({
  //     setSelectedKeys,
  //     selectedKeys,
  //     confirm,
  //     clearFilters,
  //   }) => (
  //     <div style={{ padding: 8 }}>
  //       <Input
  //         size="middle"
  //         placeholder={`Search ${dataIndex}`}
  //         value={selectedKeys[0]}
  //         onChange={(e) =>
  //           setSelectedKeys(e.target.value ? [e.target.value] : [])
  //         }
  //         onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
  //       />
  //       <div style={{ margin: 5 }} />
  //       <Button onClick={() => handleReset(clearFilters)} size="small">
  //         Reset
  //       </Button>
  //       <Button
  //         onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
  //         type="primary"
  //         size="small"
  //       >
  //         Search
  //       </Button>
  //     </div>
  //   ),
  //   filterIcon: (filtered) => (
  //     <div style={{ backgroundColor: "transparent" }}>
  //       <AiOutlineFilter />
  //     </div>
  //   ),
  //   onFilter: (value, record) =>
  //     record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
  // });
  // const handleSearch = (selectedKeys, confirm, dataIndex) => {
  //   confirm();
  //   setSearchText(selectedKeys[0]);
  //   setSearchedColumn(dataIndex);
  // };
  // const onSelectChange = (newSelectedRowKeys, rowDetails) => {
  //   props.onSelect(rowDetails);
  //   setSelectedRowKeys(newSelectedRowKeys);
  // };

  // const handleReset = (clearFilters) => {
  //   clearFilters();
  //   setSearchText("");
  // };
  const columns = [
    {
      title: "TRIP NO",
      dataIndex: "id",
      key: "id",
      width: 100,
      render: (text, record, index) => (
        <div
          onClick={() => OnSelectChange([record.id], [record])}
          className="Trip-DataTable-column"
        >
          <div className="data-table-items">{text}</div>
        </div>
      ),
    },

    {
      title: "Status",
      dataIndex: "boxes",
      key: "status",
      render: (text, record) => {
        const status = getTripStatus(record.boxes);
        return (
          <div
            onClick={() => OnSelectChange([record.id], [record])}
            className="Trip-DataTable-column"
          >
            <div className="data-table-items">
              <Tag
                color={status.color}
                style={{ color: "white", fontWeight: "bold" }}
              >
                {status.label}
              </Tag>
            </div>
          </div>
        );
      },
    },

    {
      title: "TRUCK",
      dataIndex: "truck_no",
      key: "truck_no",
      width: 300,
      render: (text, record, index) => (
        <div
          onClick={() => OnSelectChange([record.id], [record])}
          className="Trip-DataTable-column"
        >
          <div className="data-table-items">{text}</div>
        </div>
      ),
    },

    {
      title: "BOOKING DATE",
      dataIndex: "createdAt",
      key: "createdAt",
      // width: 500,
      render: (text, record, index) => (
        <div
          onClick={() => OnSelectChange([record.id], [record])}
          className="Trip-DataTable-column"
        >
          <div className="data-table-items">
            {moment(text).format("MMM Do YY")}
          </div>
        </div>
      ),
    },

    // {
    //   title: "User",
    //   dataIndex: "user",
    //   key: "user",
    //   ...getColumnSearchProps("user"),

    //   render: (text, record, index) => (
    //     <Tooltip title={record.name && record.name}>
    //       <div
    //         className="Trip-DataTable-column"
    //         onClick={() => onSelectChange([record.id], [record])}
    //       >
    //         <div className="Trip-DataTable-item">
    //           {record.user && record.user.name && record.user.name}
    //         </div>
    //       </div>
    //     </Tooltip>
    //   ),
    // },

    // {
    //   title: "VEHICLE NO",
    //   dataIndex: "truck_no",
    //   key: "truck_no",
    //   render: (text, record, index) => (
    //     <div
    //       onClick={() => OnSelectChange([record.id], [record])}
    //       className="Trip-DataTable-column"
    //     >
    //       <div className="data-table-items">{text}</div>
    //     </div>
    //   ),
    // },
    {
      title: "DRIVER NAME",
      dataIndex: "driver_name",
      key: "driver_name",
      render: (text, record, index) => (
        <div
          onClick={() => OnSelectChange([record.id], [record])}
          className="Trip-DataTable-column"
        >
          <div className="data-table-items">{text}</div>
        </div>
      ),
    },
    {
      title: "From Branch",
      dataIndex: "loggin_branch",
      key: "loggin_branch",
      render: (text, record, index) => (
        <div
          onClick={() => OnSelectChange([record.id], [record])}
          className="Trip-DataTable-column"
        >
          <div className="data-table-items">
            {record.loggin_branch && record?.loggin_branch.name}
          </div>
        </div>
      ),
    },
    {
      title: "To Branch",
      dataIndex: "to_branch",
      key: "to_branch",
      render: (text, record, index) => (
        <div
          onClick={() => OnSelectChange([record.id], [record])}
          className="Trip-DataTable-column"
        >
          <div className="data-table-items">
            {record.to_branch && record?.to_branch.name}
          </div>
        </div>
      ),
    },

    {
      title: "Total Boxes",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text, record) => (
        console.log(record),
        (
          <div>
            <Tag color="green">
              {record.boxes && record.boxes.length
                ? record.boxes.length
                : "N/A"}{" "}
              Boxes
            </Tag>
          </div>
        )
      ),
    },
    {
      title: "Total Weight",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text, record) => (
        <div className="data-table-items">
          <Tag color="blue">
            {totalWeight(record) ? `${totalWeight(record)} KG` : "N/A"}
          </Tag>
        </div>
      ),
    },

    {
      title: "Locked",
      dataIndex: "is_locked",
      key: "is_locked",
      render: (text, record, index) => (
        <div
          onClick={() => OnSelectChange([record.id], [record])}
          className="Trip-DataTable-column"
        >
          <div className="data-table-items">
            {text ? <IoLockClosed size={22} /> : <IoLockOpen size={22} />}
          </div>
        </div>
      ),
    },
  ];
  return (
    <div style={{ minHeight: "60vh" }}>
      <Table
        rowKey="id"
        columns={columns}
        rowSelection={{ type: "radio", ...rowSelection }}
        dataSource={props.data}
        pagination={false}
        size="small"
        scroll={{ x: true }}
      />
      <br />
      <div align="right">
        <Pagination
          defaultCurrent={props.meta && props.meta.page}
          total={props.meta && props.meta.itemCount}
          pageSize={props.meta && props.meta.take ? props.meta.take : 0}
          onChange={props.PageOnchange}
          pageSizeOptions={[10, 20, 50]}
        />
      </div>
    </div>
  );
}
export default DataTable2;
